import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Outlet } from 'react-router-dom';
import Navbar from './layout/navbar/navbar';
import Home from './pages/home';
import Products from './pages/products';
import Login from './pages/login';
import Employment from './pages/employment';
import Blogs from './pages/blogs';
import Shops from './pages/shops';
import Branch from './pages/branch';
import AboutUs from './pages/about-us';
import ContactUs from './pages/contact-us';

const RouterComponent = () => {
    // Layout component to conditionally render Navbar
    const Layout = () => {
        const location = useLocation();

        // لیستی از مسیرهایی که Navbar نباید نمایش داده شود
        const noNavbarRoutes = ['/'];

        // بررسی می‌کنیم که آیا مسیر فعلی در لیست مسیرهای بدون Navbar قرار دارد یا خیر
        const showNavbar = !noNavbarRoutes.includes(location.pathname);

        return (
            <>
                {showNavbar && <Navbar />}
                <Outlet /> {/* Outlet برای نمایش کامپوننت‌های فرزند */}
            </>
        );
    };

    return (
        <Router>
            <Routes>
                {/* Wrap all routes with the Layout */}
                <Route element={<Layout />}>
                    <Route path="/" element={<Login />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/employment" element={<Employment />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/shops" element={<Shops />} />
                    <Route path="/branchs" element={<Branch />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                </Route>
            </Routes>
        </Router>
    );
};

export default RouterComponent;
